var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V13.3203H8.32031V15H10ZM8.32031 9.17969V13.3203H6.67969V9.17969H8.32031ZM15 7.5V10.8203H13.3203V7.5H15ZM13.3203 5.82031V7.5H11.6797V5.82031H13.3203ZM3.32031 7.5V9.17969H1.67969V7.5H3.32031ZM1.67969 5.82031V7.5H0V5.82031H1.67969ZM7.5 1.67969V0H9.17969V1.67969H7.5ZM1.25 1.25H3.75V3.75H1.25V1.25ZM5 5V0H0V5H5ZM1.25 11.25H3.75V13.75H1.25V11.25ZM5 15V10H0V15H5ZM11.25 1.25H13.75V3.75H11.25V1.25ZM15 5V0H10V5H15ZM13.3203 13.3203H15V15H11.6797V12.5H10V10.8203H13.3203V13.3203ZM11.6797 7.5V9.17969H8.32031V7.5H11.6797ZM8.32031 5.82031V7.5H6.67969V9.17969H5V7.5H3.32031V5.82031H8.32031ZM9.17969 5H5.82031V1.67969H7.5V3.32031H9.17969V5ZM3.125 1.875V3.125H1.875V1.875H3.125ZM3.125 11.875V13.125H1.875V11.875H3.125ZM13.125 1.875V3.125H11.875V1.875H13.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.5bd3aeaa3832a6560f0996fdf8c04c73.svg";
export { ForwardRef as ReactComponent };